export const ROOT = '/'
export const LOGIN = '/login'
export const SIGN_IN = '/sign-in'
export const SIGN_UP = '/sign-up'
export const VERIFY_ACCOUNT = '/verify-account'
// SG-14362 T306 — team invitation accept screen. Unauthenticated-reachable
// (declared outside the authenticated-routes gate in BaseRoutes): the invitee
// may have no Sheetgo account yet.
export const ACCEPT_INVITATION = '/accept-invitation'
export const LOGOUT = '/logout'
export const SIGN_OUT = '/sign-out'

export const ADDON_AUTH = '/addon-auth'
export const ADDON_WELCOME = '/welcome'

export const PATH_ACCOUNT = 'account'
export const PATH_WORKFLOWS = 'workflows'
export const PATH_CONNECTIONS = 'connections'
export const PATH_NOTES = 'notes'
export const PATH_FILES = 'files'
export const PATH_FORMS = 'forms'
export const PATH_TEMPLATES = 'templates'
export const PATH_INTEGRATIONS = 'integrations'
export const PATH_DATASPACES = 'dataspaces'
export const PATH_PRIVATE_CATALOG = 'private-catalog'
export const PATH_RESOURCES = 'resources'
export const PATH_CUSTOMER_SUCCESS_STORIES = 'stories'
export const PATH_LEARNING_CENTER = 'learn'

export const HOME_WORKSPACE = '/'
export const HOME_WORKSPACE_ITEM = '/workspace/:itemId'

export const EXPLORE_PAGE = '/explore'
export const EXPLORE_TEMPLATES_PAGE = '/explore/templates'
export const EXPLORE_CUSTOMER_SUCCESS_STORIES_PAGE = `/explore/${PATH_CUSTOMER_SUCCESS_STORIES}`
export const GET_STARTED_PAGE = '/get-started'

export const ACCOUNT = `/${PATH_ACCOUNT}`
export const ACCOUNT_SUBSCRIPTION = `/${PATH_ACCOUNT}/subscription`
export const ACCOUNT_CHECKOUT = `/${PATH_ACCOUNT}/checkout`
export const ACCOUNT_INVOICES = `/${PATH_ACCOUNT}/invoices`
export const ACCOUNT_USAGE = `/${PATH_ACCOUNT}/usage`
export const ARCHIVED_WORKFLOWS = `/${PATH_ACCOUNT}/archive`
export const ACCOUNT_COMMUNICATION_SETTINGS = `/${PATH_ACCOUNT}/email-preferences`

export const PRICING = '/pricing'
export const COMMUNICATION_SETTINGS = '/email-preferences'
export const UNSUBSCRIBE_PAGE = '/one-click-unsubscribe'

export const WORKFLOW_PAGE = `/${PATH_WORKFLOWS}/:workflowId`
export const WORKFLOW_PAGE_ID = `/${PATH_WORKFLOWS}/:workflowId/:pageId*`
export const WORKFLOW_PAGE_TAB = `/${PATH_WORKFLOWS}/:workflowId/:tabId?`
export const WORKFLOW_PAGE_TAB_CONNECTIONS = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}`
export const WORKFLOW_PAGE_TAB_FILES = `/${PATH_WORKFLOWS}/:workflowId/${PATH_FILES}`
export const WORKFLOW_PAGE_TEMPLATES = `/${PATH_WORKFLOWS}/:workflowId/${PATH_TEMPLATES}`
export const WORKFLOW_PAGE_TEMPLATE = `/${PATH_WORKFLOWS}/:workflowId/${PATH_TEMPLATES}/:templateId`
export const WORKFLOW_PAGE_STORIES = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CUSTOMER_SUCCESS_STORIES}`
export const WORKFLOW_PAGE_STORY = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CUSTOMER_SUCCESS_STORIES}/:storyId`
export const WORKFLOW_PAGE_FORM = `/${PATH_WORKFLOWS}/:workflowId/${PATH_FORMS}`
export const WORKFLOW_PAGE_FORM_CREATE = `/${PATH_WORKFLOWS}/:workflowId/${PATH_FORMS}/create`
export const WORKFLOW_PAGE_FORM_ID = `/${PATH_WORKFLOWS}/:workflowId/${PATH_FORMS}/:formId`
export const WORKFLOW_CONNECTION_CREATE = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}/create`
export const WORKFLOW_CONNECTION_ACTION = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}/:id/:action`
export const WORKFLOW_CONNECTION_EDIT = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}/:id/edit`
export const WORKFLOW_CONNECTION_COPY = `/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}/:id/copy`
export const WORKFLOW_PAGE_NOTES_ID = `/${PATH_WORKFLOWS}/:workflowId/${PATH_NOTES}/:noteId`

export const WORKFLOW_CREATE = `/${PATH_WORKFLOWS}/new`
export const WORKFLOW_ADDON_CREATE = `/addon/${PATH_WORKFLOWS}/create`
export const WORKFLOW_ADDON_CONNECTION_CREATE = `/addon/${PATH_WORKFLOWS}/:workflowId/${PATH_CONNECTIONS}/create`
export const ADDON_CONNECTION_CREATE = `/addon/${PATH_WORKFLOWS}/create/builder`

export const TEMPLATES = `/${PATH_TEMPLATES}`
export const TEMPLATE_PAGE = `/${PATH_TEMPLATES}/:templateId`
export const INTEGRATIONS = `/${PATH_INTEGRATIONS}`
export const DATASPACES = `/${PATH_DATASPACES}`
export const DATASPACE_DETAIL = `/${PATH_DATASPACES}/:dataspaceId`
export const PRIVATE_CATALOG = `/${PATH_PRIVATE_CATALOG}`
export const PRIVATE_CATALOG_DETAIL = `/${PATH_PRIVATE_CATALOG}/:dataspaceId`
export const RESOURCES = `/${PATH_RESOURCES}`
export const SOLUTION_PAGE = `/solutions/install/:solutionId`

export const STORIES = `/${PATH_CUSTOMER_SUCCESS_STORIES}`
export const CUSTOMER_SUCCESS_STORY_PAGE = `/${PATH_CUSTOMER_SUCCESS_STORIES}/:storyId`

export const CONNECTION_PAGE = `/${PATH_CONNECTIONS}/:connectionId`
export const CONNECTION_CREATE_PAGE = `/${PATH_CONNECTIONS}/:connectionId/create`
// Those paths can't be plural since they would conflict with their public ones
export const CONNECTION_NO_PRESET_CREATE_PAGE = '/connection/create'
export const FORM_CREATE_PAGE = '/form/create'
export const FORM_APPROVAL_PAGE = '/form/approval'
export const DASHBOARD_PAGE_CREATE = '/dashboard/create'

export const LEARNING_CENTER_PAGE = `/${PATH_LEARNING_CENTER}`

export const PROVIDER_AUTH = '/provider-auth'

export const SSO_AUTH_TOKEN = '/sso/token'

// Public routes
export const PUBLIC_FORM = '/forms/:formId'
export const PUBLIC_DASHBOARD = '/dashboards/:dashboardId'
export const FEEDBACK_PAGE = '/feedback'
